import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";

import Markdown, { ResultDisplayMode } from "./Markdown2HTML";
import Headline from "../../Headline/Headline";
import CardDocument from "../../UI/Card/CardDocument";
import * as DocumentationUtils from "../../Utils/DocumentationUtils";
import * as DocumentationConstant from "../../Constants/DocumentationConstant";
import Spinner from "../../UI/Spinner/Spinner";
import PageNotFound from "../ErrorPage/PageNotFound";
import * as CustomEvents from "../../Constants/CustomEvents";

import LogService from "../../../middleware/CommonSdk/LogService";

const LOG_TAG = "DOCUMENTATION";

const Documentation = (props) => {
    const [docLocation, setDocLocation] = useState({ pathname: "", search: "", hash: "" });
    const [menuPath, setMenuPath] = useState("");
    const [progress, setProgress] = useState(true);
    const [displayNotFound, setDisplayNotFound] = useState(false);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect didmount");
        const sideBarUpdateAction = () => {
            LogService.debug(LOG_TAG, "sideBarUpdateAction");
            setDocLocation(prevState => { return { ...prevState } });//set new object with same value to retrig docLocation update
        };
        document.addEventListener(CustomEvents.CUSTOM_EVENT_SIDEBAR_MENU_UPDATE, sideBarUpdateAction);

        return () => {
            document.removeEventListener(CustomEvents.CUSTOM_EVENT_SIDEBAR_MENU_UPDATE, sideBarUpdateAction);
        };
    }, []);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect docLocation");
        if (docLocation.pathname.length > 0) {
            let subTitle = DocumentationUtils.getDocumentMenuPath(docLocation.pathname, true);
            if (subTitle.length === 0)
                subTitle = DocumentationUtils.getPrettyTitleFromPath(docLocation.pathname);
            setMenuPath(subTitle);
        }
    }, [docLocation]);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect location:" + props.location.pathname);
        setDisplayNotFound(false);
        setProgress(true);
        parseUrlToFindDoc();
    }, [props.location]);

    const parseUrlToFindDoc = () => {
        LogService.info(LOG_TAG, "[parseUrlToFindDoc] doc:", props.location.pathname);

        let newDocLocation = { ...props.location };
        if (DocumentationUtils.isWithoutFileExtension(newDocLocation.pathname)) {//markdown by default if no extension
            newDocLocation.pathname = newDocLocation.pathname + DocumentationConstant.MdFileExtension;
        } else if (DocumentationUtils.isMarkdownFile(newDocLocation.pathname)) {
        } else {//document not supported
            setTimeout(() => {
                LogService.warn(LOG_TAG, "[parseUrlToFindDoc] document not supported");
                setProgress(false);
                setDisplayNotFound(true);
            }, 3000);
        }

        setDocLocation(newDocLocation);
    };

    const onPageLoadedHandler = () => {
        LogService.trace(LOG_TAG, "onPageLoadedHandler");
        setProgress(false);
    };

    LogService.info(LOG_TAG, "render", "enter");

    let markdownDocument = null;
    if (DocumentationUtils.isMarkdownFile(docLocation.pathname)) {
        markdownDocument =
            <CardDocument key="documentation_1" showContent={!progress} showFiligram={DocumentationUtils.isStsDocumentation(docLocation.pathname)} showBadge={DocumentationUtils.hasBetaInUri(docLocation.search)}>
                <Markdown
                    srcLocation={docLocation}
                    displayMode={ResultDisplayMode.Normal}
                    onPageLoaded={onPageLoadedHandler}
                />
            </CardDocument>;
    }

    let displayResult = [];
    if (progress) {
        displayResult.push(<div key="documentation_0" style={{ margin: "0 50%" }}><Spinner /></div>);
        displayResult.push(markdownDocument);
    } else if (displayNotFound) {
        displayResult = <PageNotFound />;
    } else {
        displayResult.push(markdownDocument);
    }

    const title = DocumentationConstant.DocumentationTitle;
    const subtitle = menuPath;

    return (
        <div>
            <Headline
                title={title}
                subtitle={subtitle}
            />

            <div className={"content-doc content-display"}>
                {displayResult}
            </div>
        </div>
    );
}

Documentation.propTypes = {
    location: PropTypes.object
};

export default withRouter(Documentation);